import React from 'react';
import { Eye, Heart, ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    return (
        <div
            className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-100 to-amber-100 shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
            onClick={() => navigate(`/template20/product/${product.id}`)}
        >
            <div className="aspect-[3/4] overflow-hidden">
                <img
                    src={product.image || 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=400&h=500&fit=crop'}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
            </div>

            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex justify-between items-end">
                        <div>
                            <h3 className="text-white font-semibold line-clamp-1">{product.name}</h3>
                            <p className="text-orange-200 text-sm">₹{product.price}</p>
                        </div>
                        <div className="flex gap-2">
                            <button
                                className="p-2 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/40 transition-all"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    // Add to wishlist
                                }}
                            >
                                <Heart className="text-white" size={18} />
                            </button>
                            <button
                                className="p-2 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full hover:scale-110 transition-transform"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    // Add to cart
                                }}
                            >
                                <ShoppingCart className="text-white" size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {product.tag && (
                <div className="absolute top-4 right-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                    {product.tag}
                </div>
            )}
        </div>
    );
};

export default ProductCard;
